export var PaymentRequirementType = /*#__PURE__*/function (PaymentRequirementType) {
  PaymentRequirementType[PaymentRequirementType["Invalid"] = 0] = "Invalid";
  PaymentRequirementType[PaymentRequirementType["Free"] = 1] = "Free";
  PaymentRequirementType[PaymentRequirementType["SuperVIP"] = 2] = "SuperVIP";
  return PaymentRequirementType;
}({});

/**
 * 协议中的类型
 */
//# sourceMappingURL=like.js.map